import React from "react";
import { DateTime } from "luxon";
import Notice from "../../components/notice/Notice";
import Text from "../../components/typography/Text";
import Image from "../../components/images/Image";
import Button from "../../components/buttons/Button";
import Mission from "./Mission";
import NoticePost from "../../components/notice/NoticePost";

const Content = ({
  project_headline,
  project_short_description,
  project_description,
  project_image,
  loggedUser,
  last_update,
  missions,
  fetchMissions,
  notice,
  canApply,
  slug,
}) => {
  const [showPastMissions, togglePastMissions] = React.useReducer(
    s => !s,
    false
  );

  const openMissions = [];
  const pastMissions = [];
  if (missions)
    missions.forEach(mission => {
      if (mission.close) pastMissions.push(mission);
      else openMissions.push(mission);
    });

  return (
    <div>
      {missions.length < 1 && loggedUser && (
        <Notice type="success" optionName="hidden_contractor_notice" />
      )}
      {notice && loggedUser && <NoticePost notice={notice} context="project" />}
      {last_update && (
        <div className="oProjectContent_lastUpdate">
          <Text small>Last update: {formatDate(last_update)}</Text>
        </div>
      )}
      <h2 className="oProjectContent_title">{project_headline}</h2>
      <div className="oProjectContent_shortDescription">
        <Text big>{project_short_description}</Text>
      </div>
      <div className="oProjectContent_image">
        <Image image={project_image} />
      </div>
      <div className="oProjectContent_description">
        <h3>More about my project</h3>
        <Text>
          <span
            dangerouslySetInnerHTML={{ __html: project_description }}
          ></span>
        </Text>
      </div>
      <div>
        {openMissions && openMissions.length > 0 && (
          <div className="oProjectContent_missions">
            <h3>Open design jobs</h3>
            {openMissions.map(mission => (
              <Mission
                key={mission.id}
                loggedUser={loggedUser}
                mission={mission}
                refresh={fetchMissions}
                canApply={canApply}
                projectSlug={slug}
              />
            ))}
          </div>
        )}
        {pastMissions && pastMissions.length > 0 && (
          <div className="oProjectContent_toggleMissionsBtn">
            <Button
              outlined
              rounded
              onClick={togglePastMissions}
              icon={showPastMissions ? "minus" : "plus"}
            >
              {showPastMissions ? "Hide past jobs" : "Show past jobs"}
            </Button>
          </div>
        )}
        {showPastMissions && pastMissions && pastMissions.length > 0 && (
          <div className="oProjectContent_missions">
            <h3>Closed design jobs</h3>
            {pastMissions &&
              pastMissions.map(mission => (
                <Mission
                  key={mission.id}
                  loggedUser={loggedUser}
                  mission={mission}
                  refresh={fetchMissions}
                  canApply={canApply}
                  projectSlug={slug}
                />
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

const formatDate = rawDate => {
  let date = DateTime.fromISO(rawDate);
  if (!date.isValid) date = DateTime.fromISO(rawDate?.replace(/CES?T/, "T"));
  return date.toFormat("MMMM d, y");
};

export default Content;
